import React from 'react';
import OrganizationOnboardingStep from './OrganizationOnboardingStep';
import * as styles from './OrganizationOnboardingStepProfile.module.scss';
import useAppSelector from '../../app/redux/useAppSelector';
import { Field } from '../../components/Form';
import UserProfileAvatarEditor from '../../user/settings/UserProfileAvatarEditor';
import useUpdateUserProfile from '../../user/settings/useUpdateUserProfile';
import { deltaToText, textToDelta } from '../../utils/text/deltaText';

type Values = { name: string; title: string; description: string };

interface OrganizationOnboardingStepProfileProps {
  lastStep: boolean;
  step: number;
  onSkip: () => void;
  onNext: () => void;
  onPrevious: (() => void) | null;
}

const OrganizationOnboardingStepProfile = (
  props: OrganizationOnboardingStepProfileProps,
) => {
  const currentUser = useAppSelector((state) => state.session.user);
  const updateUserProfile = useUpdateUserProfile({
    user: currentUser,
  });

  return (
    <OrganizationOnboardingStep<Values>
      title="Customize your profile"
      subtitle="Enter your personal details"
      initialValues={{
        ...currentUser,
        description: deltaToText(currentUser.description),
      }}
      onSubmit={async ({ name, title, description }) => {
        await updateUserProfile({
          name,
          title,
          description: JSON.stringify(textToDelta(description)),
        });
      }}
      {...props}
    >
      <div className={styles.avatarEditorContainer}>
        <h5 className={styles.label}>Picture</h5>
        <UserProfileAvatarEditor size="medium" user={currentUser} />
      </div>
      <Field name="name" label="Name" />
      <Field name="title" label="Title" />
      <Field name="description" label="Description" type="textarea" />
    </OrganizationOnboardingStep>
  );
};

export default OrganizationOnboardingStepProfile;
